import React, { useState } from "react"

import * as styles from "./LandingMobileMenu.module.scss"
import { Link } from "gatsby"
import { useSiteQuery } from "../../../../hooks/index"

const LandingMobileMenu = ({ menuItems, setIsOpen }) => {
  const { headerButton } = useSiteQuery()
  const [openDropdown, setOpenDropdown] = useState("")

  const [childOpenState, setChildOpenState] = useState("")

  const handleLinkClick = () => {
    setOpenDropdown("")
    setChildOpenState("")
    setIsOpen(false)
  }

  return (
    <>
      <nav className={`${styles.mobileMenu}`}>
        <ul className="flex flex-col">
          {headerButton?.map((item, index) => {
            return (
              <li key={item.id || item.slug || item.title}>
                <div className={styles.level3}>
                  <a
                    href="#"
                    title={`Go to ${item.title}`}
                    onClick={handleLinkClick}
                  >
                    {item.title}
                  </a>
                </div>
              </li>
            )
          })}
        </ul>
      </nav>
    </>
  )
}

export default LandingMobileMenu
